import React from 'react';
import { Card, CardBody } from '../UI/Card';
import styles from './PreEventCountdown.module.css';

interface PreEventCountdownProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

/**
 * PreEventCountdown component
 * 
 * Displays countdown to event start with fire accent styling
 * Shows days, hours, minutes, and seconds in a prominent format
 */
export const PreEventCountdown: React.FC<PreEventCountdownProps> = ({
  days,
  hours,
  minutes,
  seconds,
}) => {
  return (
    <Card className={styles.preEventCard}>
      <CardBody>
        <div className={styles.container}>
          <h2 className={styles.title}>Iron Makers Day Begins In</h2>
          
          <div className={styles.countdown}>
            <div className={styles.timeUnit}>
              <span className={styles.value}>{days}</span>
              <span className={styles.label}>{days === 1 ? 'day' : 'days'}</span>
            </div>
            
            <span className={styles.separator}>:</span>
            
            <div className={styles.timeUnit}>
              <span className={styles.value}>{String(hours).padStart(2, '0')}</span>
              <span className={styles.label}>hours</span>
            </div>
            
            <span className={styles.separator}>:</span>
            
            <div className={styles.timeUnit}>
              <span className={styles.value}>{String(minutes).padStart(2, '0')}</span>
              <span className={styles.label}>minutes</span>
            </div>
            
            <span className={styles.separator}>:</span>
            
            <div className={styles.timeUnit}>
              <span className={styles.value}>{String(seconds).padStart(2, '0')}</span>
              <span className={styles.label}>seconds</span>
            </div>
          </div>
          
          <p className={styles.message}>Get ready to forge something amazing!</p>
        </div>
      </CardBody>
    </Card>
  );
};
